import(/* webpackMode: "eager" */ "C:\\Users\\Bradl\\GitHub\\noirpetale\\node_modules\\next\\dist\\client\\app-dir\\link.js");
